<template>
    <nav class="main-nav">
        <router-link class="nav-item" :to="{ name: 'palettes' }">
            <icon-palette class="nav-item__icon"/>
        </router-link>
        <router-link class="nav-item" :to="{ name: 'colors' }">
            <icon-colors class="nav-item__icon"/>
        </router-link>
        <router-link class="nav-item" :to="{ name: 'code' }">
            <icon-code class="nav-item__icon"/>
        </router-link>
        <router-link class="nav-item" :to="{ name: 'notes' }">
            <icon-notes class="nav-item__icon"/>
        </router-link>
        <router-link class="nav-item" :to="{name:'share'}">
            <icon-share class="nav-item__icon"/>
        </router-link>
		<a class="nav-logo" 
			href="https://statebuilt.com" 
			title="Made with love, from STATE" 
			target="_blank" 
			rel="noopener">
			<state-logo/>
		</a>
    </nav>
</template>

<script>
    import IconPalette from "../../../../Lib/Icons/IconPalette";
    import IconColors  from "../../../../Lib/Icons/IconColors";
    import IconCode    from "../../../../Lib/Icons/IconCode";
    import IconNotes   from "../../../../Lib/Icons/IconNotes";
	import IconShare   from "../../../../Lib/Icons/IconShare";
	import StateLogo   from "../../../../Lib/Icons/StateLogo";

    export default {
        name      : "main-nav",
        components: {
            IconShare,
            IconPalette,
            IconColors,
            IconCode,
			IconNotes,
			StateLogo,
        },
    }
</script>
